var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormatOverrideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.26626 2.26626C2.62129 1.91125 3.19689 1.91125 3.55192 2.26626L21.7337 20.4481C22.0887 20.8031 22.0887 21.3787 21.7337 21.7337C21.3787 22.0887 20.8031 22.0887 20.4481 21.7337L11.6235 12.9091H6.54546C6.04338 12.9091 5.63636 12.5021 5.63636 12C5.63636 11.4979 6.04338 11.0909 6.54546 11.0909H9.80526L7.09549 8.38114C5.25573 8.56147 3.81818 10.1129 3.81818 12C3.81818 14.0083 5.44624 15.6364 7.45455 15.6364H9.27273C9.7748 15.6364 10.1818 16.0434 10.1818 16.5455C10.1818 17.0476 9.7748 17.4546 9.27273 17.4546H7.45455C4.44208 17.4546 2 15.0125 2 12C2 9.64331 3.49461 7.63569 5.58766 6.87332L2.26626 3.55192C1.91125 3.19689 1.91125 2.62129 2.26626 2.26626ZM14.7273 6.54546C14.2252 6.54546 13.8182 6.95248 13.8182 7.45455C13.8182 7.95663 14.2252 8.36364 14.7273 8.36364H16.5455C18.5537 8.36364 20.1818 9.9917 20.1818 12C20.1818 12.8198 19.9116 13.5739 19.455 14.1817C19.1535 14.5831 19.2344 15.1529 19.6357 15.4546C20.0372 15.7561 20.6071 15.6752 20.9086 15.2738C21.5937 14.362 22 13.2271 22 12C22 8.98754 19.5579 6.54546 16.5455 6.54546H14.7273Z",
    fill: "currentColor",
    stroke: "#323232",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatOverrideIcon);
export default __webpack_public_path__ + "static/media/format-override-icon.a00677d8ed5a96467d526c38d8395877.svg";
export { ForwardRef as ReactComponent };